import { getCSSVariable } from "./ColorHandler";

// assignmentHelpers.js or inside your component file
const convertAssignmentToPerson = (assignment, color, colorText) => {
    return {
        first_name: assignment.first_name,
        family_name: assignment.family_name,
        img: assignment.img,
        tel: assignment.tel || "",
        email: assignment.email || "",
        aufgabe: assignment.aufgabe || "",
        position: assignment.position || "",
        show_tel: !!assignment.show_phone,
        show_email: !!assignment.show_email,
        color: getCSSVariable(color),
        colorText: getCSSVariable(colorText)
    }
};

const loadAssignment = async (id, setter, color, colorText) => {
    try {
        const res = await fetch(`/api/assignments/${id}`);
        const data = await res.json();

        setter(convertAssignmentToPerson(data, color, colorText));
    } catch (err) {
        console.error(`Failed to load assignment ${id}:`, err);
    }
};

const loadAssignmentsByArea = async (areaId, setter, color, colorText, single = false) => {
    try {
        const res = await fetch(`/api/assignments/area/${areaId}`);
        const data = await res.json();
        const personList = data.map(a => convertAssignmentToPerson(a, color, colorText));
        if (single && personList.length > 0) {
            setter(personList[0]);
        } else {
            setter(personList);
        }

    } catch (err) {
        console.error(`Failed to load area ${areaId}:`, err);
    }
};

export { loadAssignment, loadAssignmentsByArea, convertAssignmentToPerson };
